(function () {
  var KEY = 'ns_wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.unshift(handle);
    } else {
      list.splice(i, 1);
    }
    write(list);
    return i === -1;
  }

  function money(cents) {
    var n = cents / 100;
    var s = new Intl.NumberFormat('sv-SE', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(n);
    return s + ' kr';
  }

  function refreshButtons() {
    document.querySelectorAll('.ns-wish-btn').forEach(function (btn) {
      var active = has(btn.getAttribute('data-handle'));
      if (btn.classList.contains('is-active') !== active) {
        btn.classList.toggle('is-active', active);
      }
      var pressed = active ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) {
        btn.setAttribute('aria-pressed', pressed);
      }
      var label = btn.querySelector('.ns-wish-btn__label');
      if (label) {
        var want = active ? label.getAttribute('data-on') : label.getAttribute('data-off');
        if (label.textContent !== want) label.textContent = want;
      }
    });
  }

  function refreshCount() {
    var n = read().length;
    document.querySelectorAll('[data-ns-wish-count]').forEach(function (el) {
      var t = String(n);
      if (el.textContent !== t) el.textContent = t;
      var d = n > 0 ? '' : 'none';
      if (el.style.display !== d) el.style.display = d;
    });
  }

  function refreshAll() {
    refreshButtons();
    refreshCount();
  }

  function injectHeaderIcon() {
    if (document.querySelector('.ns-wish-header')) return;
    var header = document.querySelector('header, .site-header, #shopify-section-header, [id^="shopify-section"][id*="header"]');
    if (!header) return;
    var cartLink = header.querySelector('a[href$="/cart"], a[href*="/cart?"]');
    if (!cartLink) return;
    var a = document.createElement('a');
    a.href = '/pages/favoriter';
    a.className = 'ns-wish-header';
    a.setAttribute('aria-label', 'Favoriter');
    a.style.cssText = 'margin-inline-end:4px;color:inherit;';
    a.innerHTML =
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 21s-6.7-4.3-9.3-8C.8 10.2 1.6 6.6 4.5 5.2 6.6 4.2 9 4.9 12 7.6c3-2.7 5.4-3.4 7.5-2.4 2.9 1.4 3.7 5 1.8 7.8-2.6 3.7-9.3 8-9.3 8z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>' +
      '<span data-ns-wish-count style="display:none">0</span>';
    cartLink.parentNode.insertBefore(a, cartLink);
    refreshCount();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ns-wish-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    refreshAll();
    var grid = document.getElementById('ns-favorites-grid');
    if (grid) renderFavorites(grid);
  });

  function cardHtml(p) {
    var img = '';
    if (p.featured_image) {
      var sep = p.featured_image.indexOf('?') === -1 ? '?' : '&';
      img = '<img src="' + p.featured_image + sep + 'width=500" loading="lazy" alt="">';
    }
    var priceHtml = '<span class="ns-fav-card__price">' + money(p.price) + '</span>';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      priceHtml += ' <s class="ns-fav-card__compare">' + money(p.compare_at_price) + '</s>';
    }
    return (
      '<div class="ns-fav-card">' +
      '<a class="ns-fav-card__media" href="/products/' + p.handle + '">' + img + '</a>' +
      '<button type="button" class="ns-wish-btn ns-wish-btn--card is-active" data-handle="' + p.handle + '" aria-pressed="true" aria-label="Ta bort från favoriter">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 21s-6.7-4.3-9.3-8C.8 10.2 1.6 6.6 4.5 5.2 6.6 4.2 9 4.9 12 7.6c3-2.7 5.4-3.4 7.5-2.4 2.9 1.4 3.7 5 1.8 7.8-2.6 3.7-9.3 8-9.3 8z"/></svg>' +
      '</button>' +
      '<div class="ns-fav-card__info">' +
      (p.vendor ? '<p class="ns-fav-card__vendor">' + p.vendor + '</p>' : '') +
      '<h3 class="ns-fav-card__title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
      '<p class="ns-fav-card__prices">' + priceHtml + '</p>' +
      '</div>' +
      '</div>'
    );
  }

  function renderFavorites(grid) {
    var handles = read();
    var empty = document.getElementById('ns-favorites-empty');
    if (handles.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var ok = products.filter(function (p) {
        return p && p.handle;
      });
      var okHandles = ok.map(function (p) {
        return p.handle;
      });
      write(handles.filter(function (h) {
        return okHandles.indexOf(h) !== -1;
      }));
      refreshCount();
      if (ok.length === 0) {
        grid.innerHTML = '';
        if (empty) empty.style.display = '';
        return;
      }
      // Omg 13: rita temats riktiga produktkort (samma som kategorisidorna)
      // via sektionen ns-favorites. Gar det inte anvands de enkla korten.
      var sid = grid.getAttribute('data-section');
      if (!sid) {
        grid.innerHTML = ok.map(cardHtml).join('');
        return;
      }
      var q = ok.map(function (p) { return 'id:' + p.id; }).join(' OR ');
      fetch('/search?section_id=' + encodeURIComponent(sid) + '&type=product&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var ny = html ? new DOMParser().parseFromString(html, 'text/html').getElementById('ns-favorites-grid') : null;
          if (ny && ny.children.length) {
            grid.innerHTML = ny.innerHTML;
          } else {
            grid.innerHTML = ok.map(cardHtml).join('');
          }
          refreshButtons();
        })
        .catch(function () {
          grid.innerHTML = ok.map(cardHtml).join('');
        });
    });
  }

  function init() {
    injectHeaderIcon();
    refreshAll();
    var grid = document.getElementById('ns-favorites-grid');
    if (grid) renderFavorites(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fånga kort/header som laddas in senare (slider, AJAX). Debounce för att undvika loopar.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      injectHeaderIcon();
      refreshButtons();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
